import PropTypes from "prop-types";
import MyModal from "../layout/MyModal";
import AttachmentUploader from "./AttachmentUploader";

export default function AttachmentUploader_Modal({ isOpen, setIsOpen, onUpload, keikkaId = 0 }) {
  return (
    <MyModal
      title="Liitetiedostojen lähetys"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      fullWidth={true}>
      <div style={{ paddingLeft: 16, paddingRight: 16 }}>
        <AttachmentUploader onUpload={onUpload} keikkaId={keikkaId} />
      </div>
    </MyModal>
  );
}

AttachmentUploader_Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  onUpload: PropTypes.func,
  keikkaId: PropTypes.number,
};
